import { useState } from 'react';
import apiClient from "../context/apiClient";

const useFileUpload = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isUploadSuccessfull, setIsUploadSuccessfull] = useState(false);
    const [error, setError] = useState('');

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        if (file && !file.name.toLowerCase().endsWith('.xlsx')) {
            setError('Bitte wählen Sie eine Excel-Datei (.xlsx) aus');
            return;
        }
        setSelectedFile(file);
        setError('');
    };

    const handleUploadAndProcess = async (apiUrl, exportName, parameters) => {
        if (!selectedFile) {
            setError('Bitte erst eine Excel Datei auswählen');
            return;
        }

        setIsProcessing(true);
        setError('');

        const formData = new FormData();
        formData.append('file', selectedFile);

        try {
            const response = await apiClient.post(apiUrl, formData, {
                responseType: 'blob',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                params: parameters,
                withCredentials: true, // Wichtig, um Cookies mitzuschicken
            });

            if (exportName) {
                const blob = response.data;
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = exportName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }

            setSelectedFile(null);
            setIsUploadSuccessfull(true);
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) fileInput.value = '';
            setError('');
        } catch (error) {
            console.error('API request error:', error);
            setIsUploadSuccessfull(false);

            if (error.response && error.response.data instanceof Blob) {
                const errorText = await error.response.data.text();
                try {
                    // Parse the JSON error response for structured display
                    const errorJson = JSON.parse(errorText);
                    const formattedError = Object.entries(errorJson)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join('\n');
                    setError(formattedError);
                } catch (parsingError) {
                    // Fallback if the error text is not valid JSON
                    setError('Server-Fehler: ' + errorText);
                }
            } else if (error.request) {
                console.error('No response received:', error.request);
                setError('Keine Antwort vom Server erhalten.');
            } else {
                console.error('Error setting up the request:', error.message);
                setError('Fehler beim Hochladen: ' + error.message);
            }
        } finally {
            setIsProcessing(false);
        }
    };

    return { isUploadSuccessfull, selectedFile, isProcessing, error, handleFileSelect, handleUploadAndProcess };
};

export default useFileUpload;
